import { isFormArray, ValidatorFn } from '@angular/forms';

export const uniqueItemsValidator: ValidatorFn = control => {
  const controlValue = control.value;
  if (!controlValue) {
    return null;
  }
  const parent = control.parent;
  if (!parent) {
    return null;
  }
  if (!isFormArray(parent)) {
    return null;
  }
  const siblings = parent.controls;
  for (const sibling of siblings) {
    if (sibling === control) {
      break;
    }
    if (sibling.value === controlValue) {
      return { duplicate: { value: controlValue }};
    }
  }
  return null;
}